export const DELETE_COURSE_OPEN = 'DELETE_COURSE_OPEN';
export const DELETE_COURSE_CLOSE = 'DELETE_COURSE_CLOSE';

export const DELETE_LINK_OPEN = 'DELETE_LINK_OPEN';
export const DELETE_LINK_CLOSE = 'DELETE_LINK_CLOSE';
